<!--<ba-card style="margin-top:-15px;">-->
<form [formGroup]="form">
  <div class="row">
    <div class="row">
      <h4
        *ngIf="additionCost != 99"
        style="text-align: center; margin-bottom: 0px"
      >
        {{ modeTitle }} {{ _trnMainService.pageHeading }}
      </h4>
      <h4
        *ngIf="additionCost == 99"
        style="text-align: center; margin-bottom: 0px"
      >
        Add Additional Cost
      </h4>
      <mat-form-field style="margin-left: 32px; width: 9.9%">
        <input mdInput placeholder="Voucher No:" formControlName="VCHRNO" />
      </mat-form-field>
      <button
        [disabled]="TrnMainObj.Mode == 'VIEW'"
        class="btn btn-success"
        style="
          margin-top: -7px;
          border-radius: 4px;
          padding: 2px 9px;
          margin-left: 3px;
          vertical-align: middle;
        "
        id="J"
        data-toggle="modal"
        data-toggle="modal"
        data-target="#orderModal"
        value="{{ _trnMainService.prefix.VNAME }}"
      >
        {{
          _trnMainService.prefix.VNAME == null
            ? "Prefix"
            : _trnMainService.prefix.VNAME
        }}
      </button>
      <sales-mode
        *ngIf="isSales"
        [transactionType]="transactionType"
        style="display: inline-block; margin-left: 20px"
      ></sales-mode>
      <!--<creditnode-mode *ngIf="voucherType==15" style="display: inline-block; margin-left: 20px"></creditnode-mode>-->
      <!--<label style="margin-left:20px">Voucher No:</label>
            <label> {{TrnMainObj.VCHRNO}}</label>-->
    </div>
    <div class="plainBackGround" style="margin-top: -12px; padding-bottom: 0px">
      <div style="margin: 5px; margin-bottom: 0px">
        <div class="row">
          <!--<label>Voucher No:</label>
                <input type="text" style="width:90px;" [(ngModel)]="TrnMainObj.VoucherNumber">-->
          <div *ngIf="additionCost != 99" class="col-md-2">
            <mat-form-field style="width: 100%">
              <input
                mdInput
                placeholder="Chalan No:"
                formControlName="CHALANNO"
              />
            </mat-form-field>
            <!--<label style="margin-left: 15px; width:30%">Chalan No: </label>
                <input type="text" [(ngModel)]="TrnMainObj.CHALANNO" style="width:50%;">-->
          </div>

          <div *ngIf="additionCost == 99" class="col-md-2">
            <mat-form-field style="width: 100%">
              <input
                mdInput
                placeholder="Bill No:"
                formControlName="VCHRNO"
                (keydown.enter)="getAdditionalCost($event.target.value)"
              />
            </mat-form-field>
            <!--<label style="margin-left: 15px; width:30%">Chalan No: </label>
                <input type="text" [(ngModel)]="TrnMainObj.CHALANNO" style="width:50%;">-->
          </div>
          <div class="col-md-5">
            <mat-form-field style="width: 100%">
              <input
                mdInput
                type="date"
                formControlName="TRNDATE"
                style="margin-right: 5px; width: 45%"
                placeholder="Entry Date: "
                (change)="changeEntryDate($event.target.value, 'AD')"
              />A.D.
              <input
                type="text"
                formControlName="BSDATE"
                placeholder="yyyy-mm-dd"
                style="margin-left: 5px; margin-right: 5px; width: 35%"
                id="nepaliDate"
                onclick="showNdpCalendarBox('nepaliDate')"
                (change)="changeEntryDate($event.target.value, 'BS')"
                (click)="clickEntryDate($event.target.value)"
              />B.S.
            </mat-form-field>

            <!--<label >Entry Date: </label>


                <input type="date" style="margin-right: 5px;width:130px;" [(ngModel)]="TrnMainObj.TRNDATE" />

                <input type="text" style="width:100px;" [(ngModel)]="TrnMainObj.BSDATE">-->
          </div>
          <div class="col-md-5">
            <mat-form-field style="width: 100%">
              <input
                mdInput
                type="date"
                style="margin-right: 5px; width: 45%"
                formControlName="TRN_DATE"
                placeholder="Trn Date: "
                (change)="changeTrnDate($event.target.value, 'AD')"
              />A.D.
              <input
                type="text"
                style="margin-left: 5px; margin-right: 5px; width: 35%"
                formControlName="BS_DATE"
                placeholder="yyyy-mm-dd"
                onclick="showNdpCalendarBox('nepaliDate1')"
                id="nepaliDate1"
                (change)="changeTrnDate($event.target.value, 'BS')"
                (click)="clickTrnDate($event.target.value)"
              />B.S.
            </mat-form-field>
          </div>
        </div>
        <div class="row" style="margin-bottom: -5px">
          <div
            class="col-md-3"
            style="margin-top: -10px"
            *ngIf="TrnMainObj.VoucherType == 21"
          >
            <mat-form-field style="width: 60%">
              <input
                mdInput
                type="text"
                style="width: 100%"
                formControlName="REFBILL"
                placeholder="Order Ref:"
                floatPlaceholder="always"
              />
            </mat-form-field>
            <button
              style="
                margin-left: -5px;
                padding-bottom: 1.5px;
                background-color: #90b900;
                color: white;
                border-color: #90b900;
                vertical-align: text-bottom;
              "
              (click)="ReferenceLoad()"
            >
              Load
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<!--<trnmain-purchase-entry></trnmain-purchase-entry>-->

<!--</ba-card>-->

<!--<div class="row">
    <input type="button" value="Save" class="btn btn-success">
    <input type="button" value="Cancel" (click)="onCancelClicked()" class="btn btn-warning">

</div>-->
